import { Common } from './common';
import {
  BaseEhrProviderInformation,
  EhrProviderInformationPopulated,
} from './models/ehrProviderInformation';
import { EhrProviderInformation } from './models/provider';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(id: string): Promise<EhrProviderInformationPopulated> {
    const url = this.common.constructPath(`/ehr-provider-information/${id}`);
    return this.common.getJSON(url);
  }

  async findAllByPracticeIdWithProviders(
    practiceId: string,
  ): Promise<EhrProviderInformationPopulated[]> {
    const url = this.common.constructPath(
      `/ehr-provider-information/providers`,
      { practiceId },
    );
    return this.common.getJSON(url);
  }

  async upsert(
    ehrProviderInformation: BaseEhrProviderInformation,
  ): Promise<EhrProviderInformation> {
    const url = this.common.constructPath('/ehr-provider-information/');
    return this.common.putJSON(url, ehrProviderInformation);
  }

  async remove(ehrProviderInformationId: string): Promise<void> {
    const url = this.common.constructPath(
      `/ehr-provider-information/${ehrProviderInformationId}`,
    );
    return this.common.deleteJSON(url);
  }

  async update(
    ehrProviderInformationId: string,
    values: Partial<EhrProviderInformation>,
  ): Promise<EhrProviderInformation> {
    const url = this.common.constructPath(
      `/ehr-provider-information/${ehrProviderInformationId}`,
    );
    return this.common.patchJSON(url, values);
  }
}
